import { createAction, props } from '@ngrx/store';
import * as fromModels from '@models';
import { errorTypes } from '@workbook/store/workbook.reducer';

export const getViews = createAction(
  '[Workbook Component] getViews',
  props<{workbookId: number}>()
);
export const viewsLoaded = createAction(
  '[Workbook Component] viewsLoaded',
  props<{views: fromModels.View[]}>()
);

export const getDefaultView = createAction(
  '[Workbook Component] getDefaultView',
  props<{workbookId: number}>()
);
export const defaultViewLoaded = createAction(
  '[Workbook Component] defaultViewLoaded',
  props<{view: fromModels.View}>()
);

export const setWorkbook = createAction(
  '[Workbook Component] setWorkbook',
  props<{workbook: fromModels.Workbook}>()
);

export const setOpeningType = createAction(
  '[Workbook Component] setOpeningType',
  props<{workbookId: number, openAs: string}>()
);

export const setOpeningTypeResponse = createAction(
  '[Workbook Component] setOpeningTypeResponse',
  props<{success: boolean}>()
);

export const getWorkbook = createAction(
  '[Workbook Component] getWorkbook',
  props<{workbookId: number}>()
);

export const getWorkbookSuccess = createAction(
  '[Workbook Component] getWorkbookSuccess',
  props<{row: fromModels.Workbook}>()
);

export const failRequest = createAction(
  '[Workbook Component] failRequest',
  props<{error: any, errorType: errorTypes}>()
);
